import { snakeCase } from 'lodash';

export const CouponErrorEnum = {
  invalidValue: 'invalid_value',
  couponIsActive: 'coupon_is_active',
  couponHasUsesLeft: 'coupon_has_uses_left',
  couponHasCustomerUsesLeft: 'coupon_has_customer_uses_left',
  couponHasSomeProducts: 'coupon_has_some_products',
  couponPurchaseMinAmountCentsNotReached: 'coupon_purchase_min_amount_cents_not_reached',
  couponHasSomeValidItem: 'coupon_has_some_valid_item',
};

export type CouponErrorsType = (typeof CouponErrorEnum)[keyof typeof CouponErrorEnum];

export const isCouponErrorType = (type: string): boolean =>
  Boolean(CouponErrorEnum[type as keyof typeof CouponErrorEnum]);

export const toCouponErrorKeys = (rawTypes: string[]): CouponErrorsType[] =>
  rawTypes.map((type) => snakeCase(type) as CouponErrorsType);
